// getters
const  papeleriaProductsCategories = state => state.papeleriaProductsCategories

export default {
    papeleriaProductsCategories
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/categories/getters.js